"use client"
import React from "react";

import MapView from "@/components/maps/MapView";
import PropTypes from "prop-types";
import { useSearchParams } from "next/navigation";
import PageContainer from "@/components/shared/PageContainer";
import { useTenant } from "@/lib/providers/TenantProvider";

const MapPage = props => {
  const { profile } = useTenant();
  const searchParams = useSearchParams();
  const privateAccess = props.privateAccess;

  const profileName = props.match.params.name;
  const mapId = props.match.params.mapId;
  const pinId = props.match.params.pinId;
  const contributePin = searchParams.get("contribute") === "pin";
  const utmSource = searchParams.get("utm_source");
  const utmMedium = searchParams.get("utm_medium");
  const utmCampaign = searchParams.get("utm_campaign");
  var utmParams = null;
  if (utmSource) utmParams = `utm_source=${utmSource}`;
  if (utmMedium) utmParams = utmParams ? utmParams + `&utm_medium=${utmMedium}` : `utm_medium=${utmMedium}`;
  if (utmCampaign) utmParams = utmParams ? utmParams + `&utm_campaign=${utmCampaign}` : `utm_campaign=${utmCampaign}`;
  const enableComments = searchParams.get("comment") === "true";

  return (
    <PageContainer name={profileName} profile={profile} branded={true} stickyMap={true}>
      <MapView
        name={profileName}
        profile={profile}
        mapId={mapId}
        pinId={pinId}
        privateAccess={privateAccess}
        utmParams={utmParams}
        contributePin={contributePin}
        commentsEnabled={enableComments}
      />
    </PageContainer>
  );
};
MapPage.propTypes = {
  privateAccess: PropTypes.bool,
  match: PropTypes.object
};
export default MapPage;
